module.exports = __webpack_public_path__ + "components/rewards/twelve-day/static/logo-fb322fe8514d3b0633172eec0eaddfa0.webp";